import * as XLSX from 'xlsx';
import type { Transaction, TransactionSummary } from '../types';

interface ExcelRow {
  아파트명: string;
  준공년도: number;
  거래일자: string;
  금액_만원: number;
  전용면적_제곱미터: number;
  평수: number;
  층: number;
}

export function generateExcel(
  transactions: Transaction[],
  summaries: TransactionSummary[],
  regionName: string
): void {
  const workbook = XLSX.utils.book_new();

  // ========== Sheet 1: 아파트별 시세 요약 ==========
  const summaryData = summaries.map(s => ({
    '아파트명': s.aptName,
    '준공년도': s.buildYear,
    '평균매매가(만원)': s.avgPrice,
    '최저가(만원)': s.minPrice,
    '최고가(만원)': s.maxPrice,
    '평당가(만원)': s.avgPricePerPyeong,
    '거래건수': s.transactionCount,
  }));

  const summarySheet = XLSX.utils.json_to_sheet(summaryData);
  XLSX.utils.sheet_add_aoa(summarySheet, [
    ['아파트별 시세 요약 - ' + regionName],
    [],
  ], { origin: -1 });
  XLSX.utils.book_append_sheet(workbook, summarySheet, '아파트별 시세 요약');

  // ========== Sheet 2: 실거래가 내역 ==========
  const transactionData: ExcelRow[] = transactions.map(t => ({
    아파트명: t.aptName,
    준공년도: t.buildYear,
    거래일자: t.dealDate,
    금액_만원: t.dealAmount,
    전용면적_제곱미터: t.area,
    평수: Math.round(t.area / 3.3058 * 10) / 10,
    층: t.floor,
  }));

  const transactionSheet = XLSX.utils.json_to_sheet(transactionData);
  XLSX.utils.book_append_sheet(workbook, transactionSheet, '실거래가 내역');

  // ========== Sheet 3: 데이터 출처 ==========
  const sourceSheet = XLSX.utils.aoa_to_sheet([
    ['데이터 출처 및 안내'],
    [],
    ['데이터 출처'],
    ['• 국토교통부 부동산 실거래가 공공데이터'],
    ['• 호갱노노 (hogangnono.com)'],
    ['• 부킹 (buking.kr)'],
    [],
    ['생성일시', new Date().toLocaleString('ko-KR')],
    ['지역', regionName],
  ]);
  XLSX.utils.book_append_sheet(workbook, sourceSheet, '데이터 출처');

  // 다운로드
  const fileName = `${regionName.replace(/\s+/g, '_')}_아파트_매매가_${new Date().toISOString().split('T')[0]}.xlsx`;
  XLSX.writeFile(workbook, fileName);
}

export function generateCSV(transactions: Transaction[], regionName: string): void {
  const csvData = transactions.map(t => 
    `${t.aptName},${t.buildYear},${t.dealDate},${t.dealAmount},${t.area},${t.floor}`
  );
  
  const header = '아파트명,준공년도,거래일자,금액(만원),전용면적(㎡),층\n';
  const csvContent = header + csvData.join('\n');
  
  const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  
  link.setAttribute('href', url);
  link.setAttribute('download', `${regionName.replace(/\s+/g, '_')}_실거래가_${new Date().toISOString().split('T')[0]}.csv`);
  link.style.visibility = 'hidden';
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}